import { memo, useCallback } from 'react'
import FlatTabbar from 'common-components/FlatTabbar'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { AvatarVoiceTab } from 'store/types/aiAvatar'

interface IProps {
  activeTab: AvatarVoiceTab
  onTabChange: (tab: AvatarVoiceTab) => void
}

const VoiceTabs: React.FC<IProps> = ({ activeTab, onTabChange }) => {
  const handleTabClick = useCallback(
    (name: string) => onTabChange(name as AvatarVoiceTab),
    [onTabChange]
  )

  const tabs = [
    { name: AvatarVoiceTab.LIBRARY, text: translate(T.VOICE_LIBRARY_LABEL) },
    { name: AvatarVoiceTab.CLONE, text: translate(T.VOICE_CLONE_LABEL) }
  ]

  return (
    <FlatTabbar
      dataWithTexts={tabs}
      defaultActiveTabName={activeTab}
      onCurrentItemClick={handleTabClick}
    />
  )
}

export default memo(VoiceTabs)
